import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { ConfigService } from '../app.config';
import { ModelService } from './model.service';
import { ProjectData } from '../entities/project-data.entity';
import { map, retry, catchError } from 'rxjs/operators';
import { ProjectDataPerimetro } from '../entities/project-data-perimetro.entity';
import { BearerHttpService } from './bearer-http.service';
import { Utils } from '../utils.module';

declare var PDFDocument: any;
declare var blobStream: any;

@Injectable({
	providedIn: 'root'
})
export class PdfService {

	public project: ProjectData;
	public currentUserPdf: any;

	constructor(
		public http: BearerHttpService,
		public modelService: ModelService
	) { }

	//
	public getUser(userId: string): Observable<any> {
		return this.http.Get(ConfigService.REST_SERVER + '/api/userById/' + userId)
			.pipe(
				map(res => { return res; }),
				retry(1),
				catchError(this.errorHandl)
			);
	}

	// Mostrar PDF.
	public getPDF(project: ProjectData) {
		this.project = project;
		return this.http.Post(ConfigService.REST_SERVER + '/api/generatePDF/' + project._id + '/' + project.userId,
			{
				responseType: 'blob',
				projectId: project._id,
				logo: project.userId
			})
			.pipe(
				map(res => {
					return res['pdf'];
				}),
				catchError(this.errorHandl)
			);
	}

	public createPDF(logo: any, conMC: boolean) {
		this.currentUserPdf = { empresa: '' }; // userData.result; 'EMPRESA'
		this.createPDF2(logo, conMC);
	}

	// Con MC = true es el cliente final.
	public createPDF2(logo: string, conMC: boolean) {
		const doc = new PDFDocument({ autoFirstPage: false });
		const str = doc.pipe(new blobStream());

		// Crear el PDF.
		const moneda = '€';
		const pdfStyle = {
			marginLeft: 30,
			itemsY: 374,
			heightLine: 14,
			subtotal: this.modelService.getString('pdf_subtotal'),
			descuento: this.modelService.getString('pdf_descuento'),
			aplicado: this.modelService.getString('pdf_aplicado'),
			vat: this.modelService.getString('pdf_vat'),
			total: this.modelService.getString('pdf_total'),
			import: this.modelService.getString('pdf_importe'),
			header: [
				{
					text: this.modelService.getString('pdf_productCode'), x: 0, style: { width: 60, align: 'left' }, styleItem: { align: 'left' }
				}, {
					text: this.modelService.getString('pdf_description'), x: 0, style: { width: 200, align: 'left' }, styleItem: { align: 'left' }
				}, {
					text: this.modelService.getString('pdf_quantity'), x: 0, style: { width: 60, align: 'right' }, styleItem: { align: 'right' }
				}, {
					text: ' ', x: 0, style: { width: 5 }, styleItem: { align: 'right' }
				}, {
					text: this.modelService.getString('pdf_price'), x: 0, style: { width: 60, align: 'right' }, styleItem: { align: 'right' }
				}, {
					text: this.modelService.getString('pdf_discount'), x: 0, style: { width: 60, align: 'right' }, styleItem: { align: 'right' }
				}, {
					text: this.modelService.getString('pdf_importe'), x: 0, style: { width: 70, align: 'right' }, styleItem: { align: 'right' }
				}
			],
			
			init() { // Ajuste grid.
				let aux = pdfStyle.marginLeft;
				for (const h of this.header) {
					h.x = aux;
					h.styleItem.width = h.style.width;
					aux += 4 + h.style.width;
				}
			}
		};

		// En caso de ser para cliente final reajustar la grid.
		if (conMC) {
			pdfStyle.header[0].style = { width: 70, align: 'left' };
			pdfStyle.header[1].style = { width: 240, align: 'left' };
			pdfStyle.header[5].style = { width: 5 };
			pdfStyle.header[5].text = ' ';
		}
		pdfStyle.init();

		const d = new Date(this.project.fechaCreacion);
		const translate = {
			project: this.modelService.getString('pdf_project') + ' ' +this.project.nombre,
			state: this.modelService.getString('pdf_state') + ' ',
			fechaCreacion: this.modelService.getString('pdf_date') + ' ' + ('00' + d.getDate()).slice(-2) + '/'
				+ ('00' + (d.getMonth() + 1)).slice(-2) + '/' + d.getFullYear(),
			errorUnevenness: this.modelService.getString('error_unevenness'),
			comentario: this.modelService.getString('pdf_comentario') + ' : '
		};
		switch (this.project.estado) {
			case 0: translate.state += this.modelService.getString('project_list_state_draft'); break;
			case 1: translate.state += this.modelService.getString('project_list_state_review'); break;
			case 4: translate.state += this.modelService.getString('project_list_state_delivered'); break;
			case 5: translate.state += this.modelService.getString('project_list_state_cancelled'); break;
		}

		//const datas = this.project;
		const clonar = JSON.stringify(this.project);
		const datas = JSON.parse(clonar);

		let details: ProjectDataPerimetro;
		for (details of datas.perimetro) {
			details.subtotal = 0;
			//details.total = 0;
			details.totalStr = '';

			// Nuevos cambios. Si tiene el campo precioAUX viene del detalle sino viene del listado.
			// 1º si no tiene el campos precioAUX crearlo (= precio - % si lo tiene).
			for (let i = 0; i < details.grid.length; i++) {
				//8.054,13

				// const _precio = parseFloat(details.grid[i].precio.replace('€', '').replace(',', '.'));
				/* ESPRIVISA 24 - ESPRIVISA 69 
				Recibimos los datos del prespupuesto en details.grid = el precio viene en String y puede ser superior a 4 digitos, es decir, superior a 
				1000 ejemplo: 8.054,13€, en este caso, quitamos el €, despues el . y a continuación la , para tener el numero con decimales
				*/ 
				let _precio = details.grid[i].precio;
				_precio = _precio.replace('€', '')
				_precio = _precio.replace(".","");
				_precio = _precio.replace(",",".");
				_precio = Number(_precio);
				let _precioAUX = _precio;

				const _descuento = (details.grid[i].descuento) ? parseFloat(details.grid[i].descuento.replace('%', '')) : 0;
				let canStr = details.grid[i].cantidad;
				if (canStr.endsWith('.00')) { canStr = canStr.replace('.00', '');}
				else if (canStr.endsWith(',00')) { canStr = canStr.replace(',00', '');}

				details.grid[i].cantidad = canStr;
				const _cantidad = parseInt(canStr, 10);
				

				// 1º Aplicar descuento si lo tiene.
				if (_descuento > 0) {
					_precioAUX -= (_precio / 100) * _descuento;
				}
				// Si dispone de MC aplicarlo SOLO si es para el cliente.
				if (datas.mc > 0 && conMC) {
					_precioAUX = _precioAUX / ((100 - datas.mc) / 100);
				}
				// Sacar el total de la línea.
				const _total = _precioAUX * _cantidad;
				
				details.grid[i].total = Utils.formatDecimal(_total.toString()) + moneda;
				// Sumar el total de la línea al SubTotal.
				details.subtotal += _total;

				// Actualizar precio por unidad.
				details.grid[i].precioAUX = Utils.formatDecimal(_precioAUX.toString()) + moneda;
		

			}

			details.subtotalStr = Utils.formatDecimal(details.subtotal.toString()) + moneda;
			if (details.vat > 0) {
				details.vatTotal = (details.subtotal / 100) * details.vat;
			}

			details.vatTotalStr = Utils.formatDecimal(details.vatTotal.toString()) + moneda;
			details.totalStr = Utils.formatDecimal((details.vatTotal + details.subtotal).toString()) + moneda;

			doc.on('pageAdded', addHeader).addPage();
		}
		doc.end();

		str.on('finish', () => { window.open(str.toBlobURL('application/pdf')); });

		////////////////////////////////////////
		function addHeader() {
			doc.font('Helvetica-Bold').fontSize(12);
			// ################################# CABECERA PROYECTO
			const c = 145;
			doc.text(translate.project, pdfStyle.marginLeft, c).font('Helvetica');
			doc.text(translate.fechaCreacion);
			doc.text(translate.state);
			// ################################# CABECERA DISTRIBUIDOR
			if (logo) {
				doc.image("data:image/jpeg;base64," + logo, 312, 30, { align: 'center', fit: [200, 100] });
			} // .rect(312, 30, 200, 100); }
			doc.font('Helvetica');

			// ################################# GRID
			doc.font('Helvetica-Bold').fontSize(10);
			pdfStyle.header.forEach((column) => {
				doc.text(column.text, column.x, 335, column.style);
				doc.lineCap('butt').moveTo(pdfStyle.marginLeft, pdfStyle.itemsY - 8)
					.lineTo(pdfStyle.header[6].x + pdfStyle.header[6].style.width, pdfStyle.itemsY - 8)
					.stroke();
			});

			// Llenar la grid.
			doc.font('Helvetica').fontSize(10);
			let l = pdfStyle.itemsY;
			details.grid.forEach((item) => {
				doc.text(item.cod_producto, pdfStyle.header[0].x, l, pdfStyle.header[0].styleItem); // Columna del código [0].
				doc.text(item.descripcion, pdfStyle.header[1].x, l, pdfStyle.header[1].styleItem); // Columna de la decripción [1].
				doc.text(item.cantidad, pdfStyle.header[2].x, l, pdfStyle.header[2].styleItem); // Columna de la cantidad [2].
				doc.text(' ', pdfStyle.header[3].x, l, pdfStyle.header[3].styleItem); // Columna margen para que no unan [3],
				// Cuando viene con el Margen Comercial (conMC == true) se vuelca el precio con decuento y se añade el M C.
				// Si tiene Marge Comercial no se debe informar la columna de des cuento, esta columna no debe salir.
				if (conMC) {
					doc.text(item.precioAUX, pdfStyle.header[4].x, l, pdfStyle.header[4].styleItem); // Columna del precio por unidad [4].
					//doc.text(item.precio, pdfStyle.header[4].x, l, pdfStyle.header[4].styleItem); // Columna del precio por unidad [4].
					doc.text(' ', pdfStyle.header[3].x, l, pdfStyle.header[3].styleItem); // Evitar que se muestre la columna de descuento [3].
				} else {
					doc.text(item.precio, pdfStyle.header[4].x, l, pdfStyle.header[4].styleItem); // Columna del precio por unidad [4].
					doc.text(item.descuento, pdfStyle.header[5].x, l, pdfStyle.header[5].styleItem); // Columna de descueto por producto [5].
				}
				doc.text(item.total, pdfStyle.header[6].x, l, pdfStyle.header[6].styleItem); // Columna de la suma total (Cantidad x Precio) [6].
				l += pdfStyle.heightLine;
			});

			// Pie de la página.
			l = (details.grid.length * pdfStyle.heightLine) + pdfStyle.heightLine + pdfStyle.itemsY;
			doc.text(' ', 30).font('Helvetica').fontSize(10);

			doc.text(pdfStyle.subtotal, 380, l, { width: 100, align: 'right' });
			doc.text(pdfStyle.vat + details.vat + '%', { width: 100, align: 'right' });
			doc.font('Helvetica-Bold').text(pdfStyle.total, { width: 100, align: 'right' });

			doc.font('Helvetica');
			doc.text(details.subtotalStr, pdfStyle.header[6].x, l, pdfStyle.header[6].styleItem);
			doc.text(details.vatTotalStr, pdfStyle.header[6].styleItem);
			doc.font('Helvetica-Bold');
			doc.text(details.totalStr, pdfStyle.header[6].styleItem);
			doc.text('   ', 30).font('Helvetica').fontSize(12);

			// El perímetro tiene demasiado desnivel para instalar verjas. RIVISA lo tiene que revisar.
			if (details.presupuesto.error === 'verja_error_inclinacion') {
				doc.text(translate.errorUnevenness);
			}

			if (details.informacion.comentarios && details.informacion.comentarios !== '') {
				doc.text(translate.comentario + details.informacion.comentarios);
			}
		}
	}

	// Error estandar.
	private errorHandl(error: { error: { message: string; }; }) {
		let errorMessage = '';
		if (error.error instanceof ErrorEvent) {
			// Adquirir error del lado del cliente.
			errorMessage = error.error.message;
		}
		else {
			// Adquirir error del lado del servidor.
			errorMessage = 'Error code: ${error.status}\nMessage: ${error.message}';
		}
		console.log(errorMessage);
		return throwError(errorMessage);
	}
}
